import { gql } from '@apollo/client'
import { smallProductFragment } from 'Fragments'

const getFavouritesCompare = (uuids = []) => {
  if (uuids.length < 1) return null
  let tags = []
  uuids.forEach((uuid, index) => {
    tags.push(`
    compare${index}: compare (
      arguments: { productUuid: "${uuid}"}
      pagination: { page: 1, size: 4 }) {
      product {
        ...smallProduct
      }
      products {
        ...smallProduct
      } 
    }`)
  })

  return gql`
    query getFavouritesCompare {
      ${tags.join("")}
    }
    ${smallProductFragment}
  `
}

export default getFavouritesCompare
